import Swiper, { Navigation, Pagination, Controller } from 'swiper';
import MicroModal from 'micromodal';  // es6 module

const school = {
    readMoreAbout() {
        const description = document.querySelector('.school-page .description');
        const readMoreBtn = document.querySelector('.school-page .show-more');

        if (!description) {
            return
        }

        if (description.scrollHeight > 200) {

            readMoreBtn.style.display = 'inline-block';

            description.style.height = '200px';
            description.style.maxHeight = 'none';

            readMoreBtn.addEventListener('click', function (e) {
                description.classList.toggle('show-all');

                if (description.classList.contains('show-all')) {
                    description.style.height = description.scrollHeight + 'px';
                    this.textContent = 'Read less';
                    this.classList.add('show-less');

                } else {
                    description.style.height = '200px';
                    this.textContent = 'Read more';
                    this.classList.remove('show-less');
                }
            })

        }
    },
    testimonialsSlider() {
        if (document.querySelector('.testimonials')) {
            const sliderTestimonials = new Swiper('.testimonials', {
                modules: [Navigation, Pagination],
                speed: 400,
                // enabled: true,
                // noSwiping: true,
                slidesPerView: 1,
                spaceBetween: 10,
                // loop: true,
                // Navigation arrows
                navigation: {
                    nextEl: '.swiper-button-next--testimonials',
                    prevEl: '.swiper-button-prev--testimonials',
                },
                // Responsive breakpoints
                breakpoints: {
                    // when window width is >= 600px
                    600: {
                        slidesPerView: 2,
                        spaceBetween: 20
                    },
                    1000: {
                        slidesPerView: 3,
                        spaceBetween: 20
                    },
                    1200: {
                        slidesPerView: 3,
                        spaceBetween: 30
                    },
                }
            })

            sliderTestimonials.loopDestroy();
        }
    },

    gallery() {
        // Image Gallery

        const openImageGalleryBtn = document.getElementById('open-image-gallery-modal');
        const openVideoGalleryBtn = document.getElementById('open-video-gallery-modal');

        if (openImageGalleryBtn) {
            const imageGalleryTop = new Swiper('#image-gallery .gallery-top', {
                modules: [Navigation, Pagination, Controller],
                spaceBetween: 10,
                navigation: {
                    nextEl: '#image-gallery .swiper-button-next',
                    prevEl: '#image-gallery .swiper-button-prev',
                },
                pagination: {
                    el: '#image-gallery .swiper-pagination',
                    type: 'fraction',
                },
                // loop: true,
                loopedSlides: 4,
                watchOverflow: true
            });

            const imageGalleryThumbs = new Swiper('#image-gallery .gallery-thumbs', {
                modules: [Controller],
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true,
                // loop: true,
                loopedSlides: 4,
                watchOverflow: true
            });

            imageGalleryTop.controller.control = imageGalleryThumbs;
            imageGalleryThumbs.controller.control = imageGalleryTop;

            /**
             * Open the galery image
             */
            openImageGalleryBtn.addEventListener('click', () => {
                MicroModal.show('image-gallery', {
                    onShow: () => {
                        document.querySelector('body').classList.add('modal-screen-open');
                    },
                    onClose: () => {
                        document.querySelector('body').classList.remove('modal-screen-open');
                    },
                });
            });
        }

        if (openVideoGalleryBtn) {
            const videoGalleryTop = new Swiper('#video-gallery .gallery-top', {
                modules: [Navigation, Pagination, Controller],
                spaceBetween: 10,
                navigation: {
                    nextEl: '#video-gallery .swiper-button-next',
                    prevEl: '#video-gallery .swiper-button-prev',
                },
                pagination: {
                    el: '#video-gallery .swiper-pagination',
                    type: 'fraction',
                },
                // loop: true,
                loopedSlides: 4,
                watchOverflow: true
            });

            const videoGalleryThumbs = new Swiper('#video-gallery .gallery-thumbs', {
                modules: [Controller],
                spaceBetween: 10,
                centeredSlides: true,
                slidesPerView: 'auto',
                touchRatio: 0.2,
                slideToClickedSlide: true,
                // loop: true,
                loopedSlides: 4,
                watchOverflow: true
            });

            videoGalleryTop.on('slideChange', function (slide) {
                slide.$('.swiper-slide-active iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
            });

            videoGalleryTop.controller.control = videoGalleryThumbs;
            videoGalleryThumbs.controller.control = videoGalleryTop;

            /**
             * Open the gallery video
             */
            openVideoGalleryBtn.addEventListener('click', () => {
                MicroModal.show('video-gallery', {
                    onShow: () => {
                        document.querySelector('body').classList.add('modal-screen-open');
                    },
                    onClose: (modal) => {
                        document.querySelector('body').classList.remove('modal-screen-open');
                        modal.querySelectorAll('.swiper-slide iframe')[videoGalleryTop.activeIndex].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
                    },
                });
            });
        }
    },

    /**
     * Handle the download for brochures
     */
    download_brochure() {
        /**
         * Get the trigger for the modal window
         */
        const trigger = document.getElementById('open-download-brochure-modal');

        /**
         * Verify that we have the trigger for the component
         */
        if (!trigger) {
            return false;
        }

        /**
         * Attach a custom event to open the modal window
         */
        trigger.addEventListener('click', () => {
            MicroModal.show('download-brochure', {
                onShow: () => {
                    document.querySelector('body').classList.add('modal-screen-open');
                },
                onClose: () => {
                    document.querySelector('body').classList.remove('modal-screen-open');
                },
            });
        });
    },

    /**
     * Handle the switch for the featured schools tabs
     */
    featured_schools_tabs() {
        try {
            let container = document.querySelector('[data-element="featured-items"]');
            let container_empty = document.querySelector('[data-element="featured-items-empty"]');

            /**
             * Find the elements in the page that we need for the component
             */
            document.querySelectorAll('[data-toggle="featured-schools-category"]').forEach((component) => {
                /**
                 * Attach a custom click event that will hadle the elements state toggle
                 */
                component.addEventListener('click', () => {
                    /**
                     * Toggle the state of the buttons in the navigation
                     */
                    document.querySelectorAll('[data-toggle="featured-schools-category"]').forEach((button) => (button !== component) ? button.classList.remove('active') : button.classList.add('active'));

                    /**
                     * Toggle the state of the elements that match the selection of the tab
                     */
                    container.querySelectorAll('[data-element="school"]').forEach((school) => {
                        school.dataset.continents.includes(component.getAttribute('data-name')) ? school.classList.remove('hidden') : school.classList.add('hidden');
                    });
                });
            });

            /**
             * Trigger a click event to the first element in the list
             */
            if (document.querySelector('[data-toggle="featured-schools-category"]')) {
                let hash = window.location.hash;

                /**
                 * Activate the category that match the current hash
                 */
                if (document.querySelector('[data-toggle="featured-schools-category"][href="' + hash + '"]')) {
                    document.querySelector('[data-toggle="featured-schools-category"][href="' + hash + '"]').dispatchEvent(new Event('click'));
                }
            }
        } catch (error) {

        }
    },

    /**
     * Handle the management for the schools events
     */
    schools_events() {
        try {
            /**
             * Find the elements for the components
             */
            document.querySelectorAll('[data-component="schools-events"]').forEach((component) => {
                /**
                 * Find the elements that will toggle the state for the elements
                 */
                component.querySelectorAll('[data-trigger="schools-events-view-all"]').forEach((trigger) => {
                    /**
                     * Verify that the trigger does not have the event already
                     */
                    if (trigger.hasAttribute('data-event-schools-events-view-all')) {
                        return false;
                    }

                    /**
                     * Mark the element with custom attribute that we have attached an event
                     */
                    trigger.setAttribute('data-event-schools-events-view-all', true);

                    /**
                     * Create a custom event listener that will handle the process
                     */
                    trigger.addEventListener('click', () => {
                        trigger.classList.add('hidden');

                        /**
                         * Find the items in the component and toggle the state
                         */
                        component.querySelectorAll('[data-element="schools-event"]').forEach((item) => {
                            item.classList.remove('hidden');
                        });
                    });
                });
            });
        } catch (error) {

        }
    }
}

export default school;
